module.exports = __webpack_public_path__ + "media/organizations/htw-berlin-67d1f8ec.svg";